var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBeauty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.834,31.304c-2.503,1.643-5.535.319-9.096-4.552-3.879-5.308-4.081-14.891-4.081-14.891,0,0,4.728,1.235,8.729,4.091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.819,12.941c-1.903-2.047-3.616-3.331-3.616-3.331,0,0-.589,1.848-1.021,4.42,1.083.549,2.217,1.209,3.295,1.988.413-1.113.883-2.157,1.342-3.077Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.738,26.752c-1.459-1.996-2.397-4.597-3.001-7.065-3.791.253-6.982,1.357-6.982,1.357,0,0,4.528,8.079,10.256,10.444,4.716,1.947,7.769,1.69,9.354-.408-.117.041-.238.076-.361.106-2.536,1.819-5.625.549-9.266-4.435Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.166,31.304c2.503,1.643,5.535.319,9.096-4.552,3.879-5.308,4.081-14.891,4.081-14.891,0,0-4.728,1.235-8.729,4.091"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.181,12.941c1.903-2.047,3.616-3.331,3.616-3.331,0,0,.589,1.848,1.021,4.42-1.083.549-2.217,1.209-3.295,1.988-.413-1.113-.883-2.157-1.342-3.077Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m29.262,26.752c1.459-1.996,2.397-4.597,3.001-7.065,3.791.253,6.982,1.357,6.982,1.357,0,0-4.528,8.079-10.256,10.444-4.716,1.947-7.769,1.69-9.354-.408.117.041.238.076.361.106,2.536,1.819,5.625.549,9.266-4.435Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m25.785,22.268c0-6.2-4.795-13.08-4.795-13.08,0,0-4.795,6.88-4.795,13.08s1.728,9.036,4.795,9.036,4.795-2.836,4.795-9.036Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBeauty);
export default __webpack_public_path__ + "static/media/indoor-beauty.6dde12ad62922fe07386c89572170d9c.svg";
export { ForwardRef as ReactComponent };